import React, { useContext } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import TablePage from "./TablePage";
import DeadlinesPage from "./DeadlinesPage";
import CurrentCupFixturesPage from "./CurrentCupFixturesPage";
import PageHeader from "../components/PageHeader";
import H2HFixtures from "../components/H2HFixtures";
import { faFutbol } from "@fortawesome/free-solid-svg-icons";

function Home() {
  const { globalSeasonId, globalGameweek, globalLeagueMode } =
    useContext(GlobalContext);

  const h2hGameweek = Math.max(1, globalGameweek);

  return (
    <React.Fragment>
      <div className="home-widget">
        <TablePage />
      </div>

      <div className="home-widget">
        <DeadlinesPage />
      </div>

      <div className="home-widget">
        {globalLeagueMode === "HeadToHead" ? (
          <div>
            <PageHeader
              pageTitle="H2H Fixtures"
              gameweek={h2hGameweek}
              icon={faFutbol}
            />
            <H2HFixtures seasonId={globalSeasonId} gameweek={h2hGameweek} />
          </div>
        ) : (
          <CurrentCupFixturesPage />
        )}
      </div>
    </React.Fragment>
  );
}

export default Home;
